import type { HtmlString } from '~/Features/Types/HtmlString.csharp';

export const asHtmlString = (content: string): HtmlString => ({ value: content });
